import { render, staticRenderFns } from "./Notice.vue?vue&type=template&id=36ed88de&scoped=true"
import script from "./Notice.vue?vue&type=script&lang=js"
export * from "./Notice.vue?vue&type=script&lang=js"
import style0 from "./Notice.vue?vue&type=style&index=0&id=36ed88de&prod&lang=css"
import style1 from "./Notice.vue?vue&type=style&index=1&id=36ed88de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ed88de",
  null
  
)

export default component.exports